import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { PromotionReportPage, RedemptionLedgerPage } from "@/features/promotion";

// Spec §5.5/§5.6: the report (GWP quota/used/remaining) plus the redemption
// ledger stacked beneath it. Each composed page is self-labeled and self-fetching.
function PromotionReportRoute(): JSX.Element {
  return (
    <div className="space-y-10">
      <PromotionReportPage />
      <RedemptionLedgerPage />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/promotion-report")({
  component: PromotionReportRoute,
});
